const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3000/api/v1";

export async function login(email, password) {
  try {
    const resp = await fetch(`${API_BASE}/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const text = await resp.text();

    if (!resp.ok) {
      let errorMsg = text;
      try {
        const json = JSON.parse(text);
        errorMsg = json.message || json.error || text;
      } catch (e) {
        // text já é a mensagem
      }
      
      throw new Error(errorMsg || `HTTP ${resp.status}`);
    }

    const data = JSON.parse(text);

    if (!data.token) {
      console.error("[api.login] Token não recebido:", data);
      throw new Error("Token não recebido da resposta");
    }

    localStorage.setItem("token", data.token);
    if (data.refreshToken) {
      localStorage.setItem("refreshToken", data.refreshToken);
    }

    return data;
  } catch (err) {
    throw err;
  }
}

export default {
	login,
};
